import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import Slide from '@material-ui/core/Slide';
import DropDown from '../ui/react-ui/dropdown';
import MapAnalyticsMap from './mapAnalytics-map';
import MapAnalyticsTable from './mapAnalytics-table'; // Api

import { getEventTrafficGeographic, getVdsGeographic } from '../../api/deviceAPI';
import { getAreaTerminalsGeographic, getAreaGatesGeographic } from '../../api/areaAPI';
import { getTrafficEventListPublished } from '../../api/eventAPI'; // Redux

import { setMarkerList, setSelectedArea, setEventMarkerList, setEventTableList, setShowFilterBlock, setShowTable } from '../../redux/traffic-prediction';
var t = i18n.getFixedT(null, 'traffic-prediction');
var MapAnalytics = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$trafficP = _useSelector.trafficPrediction,
      mapBounds = _useSelector$trafficP.mapBounds,
      eventTypeList = _useSelector$trafficP.eventTypeList,
      selectedArea = _useSelector$trafficP.selectedArea,
      markerList = _useSelector$trafficP.markerList,
      eventMarkerList = _useSelector$trafficP.eventMarkerList,
      eventTableSort = _useSelector$trafficP.eventTableSort,
      showFilterBlock = _useSelector$trafficP.showFilterBlock,
      showTable = _useSelector$trafficP.showTable,
      _useSelector$app = _useSelector.app,
      zonesListData = _useSelector$app.zonesListData,
      zonesList = _useSelector$app.zonesList,
      isMobileDevice = _useSelector$app.isMobileDevice;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      eventTypeFilter = _useState2[0],
      setEventTypeFilter = _useState2[1];

  var isMounted = useRef(false);

  var handleAreaChange = function handleAreaChange(val) {
    var areaData = _.find(zonesListData, function (el) {
      return el.id === val;
    });

    dispatch(setSelectedArea(areaData));
  };

  var handleEventTypeFilter = function handleEventTypeFilter(id) {
    if (eventTypeFilter.indexOf(id) >= 0) {
      var newFilterItems = _.cloneDeep(eventTypeFilter);

      _.remove(newFilterItems, function (o) {
        return o === id;
      });

      setEventTypeFilter(newFilterItems);
    } else {
      setEventTypeFilter([].concat(_toConsumableArray(eventTypeFilter), [id]));
    }
  };

  var renderEventTypeListFilter = function renderEventTypeListFilter() {
    return _.map(eventTypeList, function (el) {
      return /*#__PURE__*/React.createElement("div", {
        className: cx('eventType-item', {
          'disable': eventTypeFilter.indexOf(el.id) >= 0
        }),
        onClick: function onClick() {
          return handleEventTypeFilter(el.id);
        }
      }, eventTypeFilter.indexOf(el.id) >= 0 ? /*#__PURE__*/React.createElement("i", {
        class: "fas fa-eye-slash"
      }) : /*#__PURE__*/React.createElement("i", {
        class: "fas fa-eye"
      }), /*#__PURE__*/React.createElement("span", null, el.name));
    });
  };

  var handleOpenFilterBlock = function handleOpenFilterBlock() {
    if (showTable) return;
    dispatch(setShowFilterBlock(!showFilterBlock));
  };

  var handleShowEventTable = function handleShowEventTable() {
    dispatch(setShowTable(!showTable));
  };

  useEffect(function () {
    if (!isMounted.current) return;

    var eventMarkers = _.filter(eventMarkerList, function (el) {
      return eventTypeFilter.indexOf(el.typeId) === -1;
    });

    var exceptEventMarker = _.filter(markerList, function (el) {
      return el.dataType !== 'event';
    });

    dispatch(setMarkerList([].concat(_toConsumableArray(eventMarkers), _toConsumableArray(exceptEventMarker))));
  }, [JSON.stringify(eventTypeFilter)]);
  useEffect(function () {
    if (isMounted.current && !_.isEmpty(mapBounds)) {
      var latLngStart = mapBounds._southWest,
          latLngEnd = mapBounds._northEast;
      var getEvent_api = getEventTrafficGeographic(contextRoot, true, latLngStart, latLngEnd);
      var getTerminals_api = getAreaTerminalsGeographic(contextRoot, true, latLngStart, latLngEnd);
      var getGates_api = getAreaGatesGeographic(contextRoot, true, latLngStart, latLngEnd);
      var getVds_api = getVdsGeographic(contextRoot, true, latLngStart, latLngEnd);
      $.when(getEvent_api, getTerminals_api, getGates_api, getVds_api).then(function (event_result, termainals_result, gates_result, vds_result) {
        var markers = [];

        var markers_gates = _.map(gates_result.content, function (el) {
          return _objectSpread({
            dataType: 'gate'
          }, el);
        });

        var markers_terminals = _.map(termainals_result.content, function (el) {
          return _objectSpread({
            dataType: 'terminal'
          }, el);
        }); // filter event type


        var markers_event = _.map(event_result.content, function (el) {
          return _objectSpread({
            dataType: 'event'
          }, el);
        });

        dispatch(setEventMarkerList(markers_event));

        var eventMarkers = _.filter(markers_event, function (el) {
          return eventTypeFilter.indexOf(el.typeId) === -1;
        });

        var markers_vds = _.map(vds_result.content, function (el) {
          return _objectSpread({
            dataType: 'vd'
          }, el);
        });

        markers = [].concat(_toConsumableArray(markers_gates), _toConsumableArray(markers_terminals), _toConsumableArray(eventMarkers), _toConsumableArray(markers_vds));
        dispatch(setMarkerList(markers));
      }).catch(function (error) {
        console.log(error);
      });
    }
  }, JSON.stringify(mapBounds));
  useEffect(function () {
    if (!isMounted.current) {
      getTrafficEventListPublished(contextRoot, false, '', eventTableSort, 0, null).then(function (result) {
        var now = moment().valueOf();

        var eventData = _.filter(result.content, function (el) {
          if (_.isEmpty(el.endTime)) return true;
          var endTime = moment(el.endTime).valueOf();
          return endTime > now;
        });

        var events = _.map(eventData, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: index + 1
          });
        });

        dispatch(setEventTableList(events));
      });
      isMounted.current = true;
    }

    return function () {
      setEventTypeFilter([]);
      dispatch(setSelectedArea({}));
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "map-analytics"
  }, isMobileDevice ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('slide-icon', {
      'close': showFilterBlock
    }),
    onClick: handleOpenFilterBlock
  }, showFilterBlock ? /*#__PURE__*/React.createElement(ArrowLeftIcon, null) : /*#__PURE__*/React.createElement(ArrowRightIcon, null)), /*#__PURE__*/React.createElement(Slide, {
    direction: "right",
    in: showFilterBlock,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true,
    timeout: 500
  }, /*#__PURE__*/React.createElement("div", {
    className: "left-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('lbl-select-area')), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-select'),
    list: zonesList,
    value: selectedArea ? selectedArea.id : '',
    onChange: handleAreaChange,
    width: "180px"
  }), /*#__PURE__*/React.createElement("div", {
    className: "filter-block"
  }, renderEventTypeListFilter())))) : /*#__PURE__*/React.createElement("div", {
    className: "left-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('lbl-select-area')), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-select'),
    list: zonesList,
    value: selectedArea ? selectedArea.id : '',
    onChange: handleAreaChange,
    width: "180px"
  }), renderEventTypeListFilter()), /*#__PURE__*/React.createElement(MapAnalyticsMap, null), /*#__PURE__*/React.createElement(MapAnalyticsTable, {
    isShowTable: isMobileDevice ? showTable : true
  }), isMobileDevice && /*#__PURE__*/React.createElement("div", {
    className: "table-icon-wrap",
    onClick: function onClick() {
      return handleShowEventTable();
    }
  }, showTable ? /*#__PURE__*/React.createElement("i", {
    className: "fas fa-times"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "far fa-file-alt"
  })));
});
export default MapAnalytics;